module.exports = __webpack_public_path__ + "school/img/hanMedicineHealthPreservationBg.4bd323f9.jpg";